<template>
    <div class="blog-details-area ptb-100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-12">
                    <div class="blog-details-desc">
                        <div class="article-image">
                            <img src="../../assets/images/blog/pediatric-dentistry/pediatric_page.webp" alt="image">

                        </div>

                        <div class="article-content">
                            <div class="row">
                              

                                <h2><u>{{ $t('blog_page_pediatric_title') }}</u></h2>
                                <p>{{ $t('blog_page_pediatric_p') }}</p>
                            
                                <div class="separate"></div>

                                <div class="row align-items-center">
                                    <div class="col-lg-6 services-details">
                                        <div class="services-details-desc">
                                            <h3>{{ $t('blog_page_pediatric_limit_title') }}</h3>
                                            <p >{{ $t('blog_page_pediatric_limit_p') }}</p>

                                        </div>
                                    </div>
                                    <div class="col-lg-6 services-details-image">
                                        <img src="../../assets/images/blog/pediatric-dentistry/toomuch-sugar.webp" alt="image">
                                    </div>

                                </div>

                                <div class="separate"></div>
                                    <div class="row align-items-center">
                                        <div class="col-lg-6 services-details-image">
                                            <img src="../../assets/images/blog/pediatric-dentistry/paidodontia-brushing.webp" alt="image">
                                        </div>

                                        <div class="col-lg-6 services-details">
                                            <div class="services-details-desc">
                                                <h3>{{ $t('blog_page_pediatric_everyday_title') }}</h3>
                                                 <p >{{ $t('blog_page_pediatric_everyday_p') }}</p>                                
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row align-items-center">
                                            <div class="col-lg-6 services-details">
                                                <div class="services-details-desc">
                                                    <h3>{{ $t('blog_page_pediatric_appointment_title') }}</h3>
                                                    <p>
                                                        {{ $t('blog_page_pediatric_apointment_p') }}
                                                       
                                                    </p>
                                                </div>
                                            </div>

                                        <div class="col-lg-6 services-details-image">
                                            <img src="../../assets/images/blog/pediatric-dentistry/dentist-visit.webp" alt="image">                            
                                        </div>
                                       
                                </div>
                                
                            </div>
                            
                            
                            <p>{{ $t('blog_page_pediatric_conclusion_p') }}</p>
                            <div class="article-tag">
                                <span>Share:</span>
                                <a href="https://www.facebook.com/" target="_blank"><i class='bx bxl-facebook'></i></a>
                                <a href="https://twitter.com/?lang=en" target="_blank"><i class='bx bxl-twitter'></i></a>
                                <a href="https://www.linkedin.com/" target="_blank"><i class='bx bxl-linkedin'></i></a>
                                <a href="https://www.instagram.com/" target="_blank"><i class='bx bxl-instagram'></i></a>
                            </div>
                        </div>

                        
                    </div>
                </div>

                
                
            </div>
        </div>
    </div>
</template>


<script>

export default {
    name: 'PediatricDentistry',
    
}
</script>
